module.exports = __webpack_public_path__ + "media/assets/images/category/MothersDay@2x-fe7f25fb2724a0b422fd714d37ec216c.png";